export const STORE_FILTER_GROUPS = 'casino/STORE_FILTER_GROUPS';
export const STORE_LOBBY_TYPES = 'casino/STORE_LOBBY_TYPES';
export const SELECT_FILTER_TAG = 'casino/SELECT_FILTER_TAG';
export const DESELECT_FILTER_TAG = 'casino/DESELECT_FILTER_TAG';
export const FETCH_FILTER_GROUPS = 'casino/FETCH_FILTER_GROUPS';
export const STORE_FILTER_RESULT = 'casino/STORE_FILTER_RESULT';
export const RESET_ALL = 'casino/RESET_ALL';
export const STORE_FILTER_TAGS_IN_URL = 'casino/STORE_FILTER_TAGS_IN_URL';
